function removeLineBreaks(value) {
  return value.replace(/(\r\n|\n|\r)/gm, '');
} // TAKEN FROM - https://github.com/janl/mustache.js/blob/master/mustache.js#L55

var htmlEntityMap = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
  '/': '&#x2F;',
  '`': '&#x60;',
  '=': '&#x3D;'
};
function escapeHtml(value) {
  return String(value).replace(/[&<>"'`=/]/g, function (s) {
    return htmlEntityMap[s];
  });
}
function safeHtmlString(value) {
  return escapeHtml(removeLineBreaks(value));
}

export { escapeHtml, removeLineBreaks, safeHtmlString };
//# sourceMappingURL=functions.esm.js.map
